import { render, staticRenderFns } from "./KeyValue.vue?vue&type=template&id=2e4c2bcc&scoped=true&lang=pug&"
import script from "./KeyValue.vue?vue&type=script&lang=js&"
export * from "./KeyValue.vue?vue&type=script&lang=js&"
import style0 from "./KeyValue.vue?vue&type=style&index=0&id=2e4c2bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c2bcc",
  null
  
)

export default component.exports